import {useEffect, useRef, useState} from 'react';
import {useLocation} from 'react-router-dom';
import {Box, makeStyles} from '@material-ui/core';
import Page from '../../atoms/layout/page';
import Sidebar from './sidebar';
import IconButton from '@material-ui/core/IconButton';
import ListIcon from '@material-ui/icons/List';
import {UserProfileComponent} from "./userProfile";
import UtilService from "../../../helper/service";
import roles from "../../../helper/roles";
import {getUserMetricValue} from "../../../store/actions/creator/creatorExperienceBuilder";
import {useDispatch, useSelector} from "react-redux";

const useStyles = makeStyles((theme) => ({
  root: {
    height: '100%',
    display: 'flex',
    position: 'relative',
    zIndex: 1
  },
  menu: {
    position: 'absolute',
    right: 10,
    top: 10,
    borderRadius: 20,
    width: 40,
    height: 40,
    [theme.breakpoints.up('md')]: {
      display: 'none'
    }
  }
}));

function MailView() {
  const classes = useStyles();
  const pageRef = useRef(null);
  const location = useLocation();
  const dispatch = useDispatch();
  const { globalSaveSetting, globalCompatible } = useSelector((state: any) => state.creatorExperienceBuilder);
  const loginUserData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || '{}') : "";
  const apolloClient = useSelector((state: any) => state.apolloClient);
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [path, setPath] = useState('');

  useEffect(() => {
    const request = {
      metrix_type: 'EXPERIENCE_CREATE_SETTING',
      user_id: Number(loginUserData.user_id)
    };
    dispatch(getUserMetricValue(apolloClient.client, request));
  }, []);

  useEffect(() => {
    let _path = location.pathname.substr(14);
    if (!!loginUserData) {
      if (UtilService.checkTrialAccess(loginUserData, roles['trial']['profile'])) {
        _path = location.pathname.substr(25);
      }
    }
    setPath(_path);
  }, [loginUserData, location]);

  const isTrial = () => {
    const userData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || '{}') : "";
    if (!!userData && userData.department_id) {
      return true;
    } else {
      return false;
    }
  };

  const isTeamOwner = () => {
    const userData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || '{}') : "";
    if (!!userData && userData.department_id && userData.role_description && userData.role_description.toLowerCase().includes('admin')) {
      return true;
    }
    return false;
  };

  return (
    <Page
      className={classes.root}
      title={"Profile"}
      ref={pageRef}
    >
      <Sidebar containerRef={pageRef} sidebarOpen={sidebarOpen} closeSidebar={()=>setSidebarOpen(false)}/>

      <Box m={4}>
        <IconButton onClick={()=>setSidebarOpen(true)} className={classes.menu} color="primary" aria-label="add to shopping cart">
          <ListIcon />
        </IconButton>
        <UserProfileComponent
          path={path}
          isTrial={isTrial()}
          isTeamOwner={isTeamOwner()}
          globalSaveSetting={globalSaveSetting}
          globalCompatible={globalCompatible}
        />
      </Box>
    </Page>
  );
}

export default MailView;
